import axios from 'axios';

import { setAlert } from './alert';
import { changeLoader } from './loader';
import { PROVEEDORES } from './types';

export const buscarProveedores = (filtros = {}) => async dispatch => {
    const config = { headers: { 'Content-Type': 'application/json' } };
    const body = JSON.stringify(filtros);

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/proveedores/listar`, body, config);
        await dispatch({ type: PROVEEDORES.BUSCAR, payload: res.data.proveedores });
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const crearProveedor = (proveedorData) => async dispatch => {
    const config = { headers: { 'Content-Type': 'application/json' } };
    const body = JSON.stringify(proveedorData);

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/proveedores/crear`, body, config);
        await dispatch({ type: PROVEEDORES.AGREGAR, payload: res.data.proveedor });
        await dispatch(setAlert(res.data.msg || 'Proveedor creado correctamente', 'success'));
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const editarProveedor = (proveedorData) => async dispatch => {
    const config = { headers: { 'Content-Type': 'application/json' } };
    const body = JSON.stringify(proveedorData);

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/proveedores/editar`, body, config);
        await dispatch({ type: PROVEEDORES.EDITAR, payload: res.data.proveedor });
        await dispatch(setAlert(res.data.msg || 'Proveedor editado correctamente', 'success'));
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const eliminarProveedor = (id) => async dispatch => {
    const config = { headers: { 'Content-Type': 'application/json' } };
    const body = JSON.stringify({ id });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/proveedores/eliminar`, body, config);
        await dispatch({ type: PROVEEDORES.ELIMINAR, payload: id });
        await dispatch(setAlert(res.data.msg || 'Proveedor eliminado correctamente', 'success'));
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const obtenerProveedor = (id) => async dispatch => {
    const config = { headers: { 'Content-Type': 'application/json' } };
    const body = JSON.stringify({ id });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/proveedores/detalles`, body, config);
        await dispatch({ type: PROVEEDORES.DETALLES, payload: res.data.proveedor });
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const perfilProveedor = (id) => async dispatch => {
    const config = { headers: { 'Content-Type': 'application/json' } };
    const body = JSON.stringify({ id });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/proveedores/perfil`, body, config);
        await dispatch({ type: PROVEEDORES.PERFIL, payload: res.data.proveedor });
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const limpiarProveedor = () => dispatch => {
    dispatch({ type: PROVEEDORES.LIMPIAR });
};
